// Обертка над Web Speech API (Speech-to-Text)
let SpeechRecognitionAPI = null;

if (typeof window !== 'undefined') {
  SpeechRecognitionAPI = window.SpeechRecognition || window.webkitSpeechRecognition;
}

export const isRecognitionSupported = () => Boolean(SpeechRecognitionAPI);

export const createRecognition = ({ lang = 'ru-RU', continuous = true, interimResults = true } = {}) => {
  if (!SpeechRecognitionAPI) return null;

  const recognition = new SpeechRecognitionAPI();
  recognition.lang = lang;
  recognition.continuous = continuous;
  recognition.interimResults = interimResults;
  
  return recognition;
};